module.exports = __webpack_public_path__ + "img/jobs_example4.575c0104.jpg";